import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import { OperationsIcon, HealthProgramsIcon, ResponseIcon, ParticipationIconAlt } from './Icons';
import './Partners.css';

const Partners = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const partnerLogos = [
    { name: 'HAC', logo: '/MRRO/Media/partners/hac.jpg' },
    { name: 'Health Ministry', logo: '/MRRO/Media/partners/health.jpg' },
    { name: 'NCCWSG', logo: '/MRRO/Media/partners/nccwsg.jpg' },
    { name: 'OCHA', logo: '/MRRO/Media/partners/ocha.png' },
    { name: 'Save the Children', logo: '/MRRO/Media/partners/Save-the-children-logo.png' }
  ];

  const collaborationItems = [
    { Icon: OperationsIcon, text: t.facilitateOperations },
    { Icon: HealthProgramsIcon, text: t.supportHealthPrograms },
    { Icon: ResponseIcon, text: t.strengthenResponse },
    { Icon: ParticipationIconAlt, text: t.enhanceParticipation }
  ];

  return (
    <section id="partners" className="partners">
      <div className="container">
        <div className="section-header">
          <h2>{t.partnersTitle}</h2>
          <p>{t.partnersIntro}</p>
        </div>

        {/* Partner Logos Section */}
        <div className="partner-logos-section">
          <h3>{language === 'ar' ? 'شركاؤنا' : 'Our Partners'}</h3>
          <div className="partner-logos-grid">
            {partnerLogos.map((partner, index) => (
              <div key={index} className="partner-logo-card">
                <img src={partner.logo} alt={partner.name} className="partner-logo" />
              </div>
            ))}
          </div>
        </div>

        <div className="collaboration-focus">
          <h3>{t.collaborationFocus}</h3>
          <div className="focus-grid">
            {collaborationItems.map((item, index) => (
              <div key={index} className="focus-item">
                <div className="focus-icon">
                  <item.Icon />
                </div>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
